import { cn } from "@/utils/cn";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

interface Option {
  icon: React.ReactNode;
  text?: string;
  hoverClass?: string;
  url?: string;
  onClick?: () => void;
  disabled: boolean;
}

interface Props {
  children: React.ReactNode;
  onlyIcons?: boolean;
  options: Option[];
  className?: string;
}

export const CustomMenu: React.FC<Props> = ({
  children,
  options,
  onlyIcons = false,
  className,
}) => {
  return (
    <Menu as="div" className={cn("relative inline-block text-left", className)}>
      <div>
        <Menu.Button className="inline-flex w-full justify-center rounded-md text-sm font-medium text-white focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white/75">
          {children}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={cn(
            "absolute right-0 z-99 mt-2 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg focus:outline-hidden",
            {
              "w-48": !onlyIcons,
            },
          )}
        >
          {options.map(
            ({ text, icon, hoverClass, url, onClick, disabled }, i) => (
              <div key={i} className="x-1 y-1">
                {!disabled && (
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={cn(
                          "hover:bg-sur flex w-full shrink-0 items-center space-x-4 p-3 text-sm",

                          {
                            "text-gray-900": !active,
                            "bg-whiteSmoke text-black": active,
                          },
                          hoverClass && active && hoverClass,
                        )}
                        onClick={() => {
                          if (url) window.open(url, "_blank");
                          else if (onClick) onClick();
                        }}
                      >
                        {icon}
                        {text && <p>{text}</p>}
                      </button>
                    )}
                  </Menu.Item>
                )}
              </div>
            ),
          )}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
export default CustomMenu;
